var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9664_24384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.499999 0.25H8C8.15 0.25 8.25 0.35 8.25 0.5V3.75H11.5C11.65 3.75 11.75 3.85 11.75 4V11.5C11.75 11.65 11.65 11.75 11.5 11.75H4C3.85 11.75 3.75 11.65 3.75 11.5V8.25H0.499999C0.349998 8.25 0.249999 8.15 0.249999 8V0.5C0.249999 0.35 0.349998 0.25 0.499999 0.25ZM4.25 7.75H7.75V4.25H4.25V7.75Z",
    fill: "#797B80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9664_24384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclude);
export default __webpack_public_path__ + "static/media/exclude.57b2b203536053f69643fbca1c798bf3.svg";
export { ForwardRef as ReactComponent };